import { detailFieldStyles } from '@v2/components';

export const styles = {
  fieldContainer: detailFieldStyles.fieldContainer,
  fieldFullWidth: 'tw-col-span-2',
  emptyText: 'tw-text-sm tw-text-neutral-500 tw-p-2',
  cardGrid:
    'tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-2 tw-p-2 tw-max-h-[50vh] tw-overflow-y-auto tw-overflow-x-hidden tw-content-start tw-auto-rows-min tw-items-stretch',
};
